import React from 'react';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';
import { DateTimeTooltip } from '@components/main-components/datetime-tooltip';
import { useTimer } from '@hooks/useTimer';
import { SPACE } from '@utils/constants';
import { DataTestId } from '@utils/test';

export const TextTimerBadge = ({
  label,
  expiryTimestamp,
}: {
  label: string;
  expiryTimestamp: number;
}) => {
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp: expiryTimestamp,
  });

  const endsInDate = React.useMemo(() => new Date(expiryTimestamp), [expiryTimestamp]);

  const moreThan24 = days > 0;
  const distance = React.useMemo(
    () =>
      moreThan24 ? formatDistanceToNowStrict(expiryTimestamp, { roundingMethod: 'floor' }) : null,
    [moreThan24, expiryTimestamp],
  );

  return (
    <DateTimeTooltip dateTime={endsInDate} prefix="Ends on ">
      <div
        className="w-fit rounded-full bg-neutral900 px-2 py-1 font-base text-base-s font-semibold text-white"
        data-testid={DataTestId.TIMER_BADGE}
      >
        {moreThan24 ? `${label} in` : label}
        {SPACE}
        {moreThan24 ? (
          distance
        ) : (
          <span className="font-numerals font-bold tabular-nums">
            {hours > 0 && `${String(hours).padStart(2, '0')}:`}
            {minutes >= 0 && `${String(minutes).padStart(2, '0')}:`}
            {days === 0 && minutes >= 0 && seconds >= 0 && `${String(seconds).padStart(2, '0')}`}
          </span>
        )}
      </div>
    </DateTimeTooltip>
  );
};
